import { render } from "./AttachFileDownloadModal.vue?vue&type=template&id=42cb4abd"
import script from "./AttachFileDownloadModal.vue?vue&type=script&lang=js"
export * from "./AttachFileDownloadModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__